import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/GridLegacy';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface PropTypes {
  name: string;
  title?: string;
  avatar?: string;
  about?: string;
}

function TeamContainer(props: PropTypes): JSX.Element {
  const theme = useTheme();
  return (
    <Grid item xs={12} sm={6} md={3}>
      <Box
        component={Card}
        boxShadow={2}
        height={1}
        sx={{
          textDecoration: 'none',
          transition: 'all .2s ease-in-out',
          '&:hover': {
            transform: `translateY(-${theme.spacing(1 / 2)})`,
          },
        }}
      >
        <CardContent>
          {props.avatar && <Box component={Avatar} src={props.avatar} height={80} width={80} marginBottom={4} />}
          <Box>
            <ListItemText
              primary={props.name}
              secondary={props.title}
              primaryTypographyProps={{ variant: 'h6', fontWeight: 700 }}
              secondaryTypographyProps={{ variant: 'subtitle1' }}
            />
            <Typography variant={'subtitle2'} color={'text.secondary'}>
              {props.about}
            </Typography>
            {/* <Box marginTop={4}>
              <IconButton size={'small'} color={'primary'}>
                <FacebookIcon />
              </IconButton>
              <IconButton size={'small'} color={'primary'}>
                <GitHubIcon />
              </IconButton>
              <IconButton size={'small'} color={'primary'}>
                <TwitterIcon />
              </IconButton>
            </Box> */}
          </Box>
        </CardContent>
      </Box>
    </Grid>
  );
}

export default TeamContainer;
